/**********************************
 * Cookie functions
 * filename: worldpantry_fast_ship.js
 ***********************************/

// Sets a cookie with the given name and value for the current session
function setSessionCookie(name, value) {
    if (!name || value === null || value === undefined) {
        console.warn('Invalid cookie parameters:', name, value);
        return;
    }

    try {
        const encodedValue = encodeURIComponent(value);
        document.cookie = `${name}=${encodedValue}; path=/; SameSite=Lax`;
    } catch (error) {
        console.error('Error setting cookie:', error);
    }
}

// Gets a cookie with the given name
function getSessionCookie(name) {
    if (!name) {
        console.warn('Cookie name is required');
        return null;
    }

    try {
        const nameKey = name + "=";
        const cookies = document.cookie.split(';');

        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.indexOf(nameKey) === 0) {
                return decodeURIComponent(cookie.substring(nameKey.length));
            }
        }
        return null;
    } catch (error) {
        console.error('Error getting cookie:', error);
        return null;
    }
}

/**********************************
 * Legacy cookie functions (for compatibility)
 ***********************************/

function getCookie(name) {
    if (!name || !document.cookie.length) {
        return "";
    }

    try {
        const nameKey = name + "=";
        const cookies = document.cookie.split(';');

        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.indexOf(nameKey) === 0) {
                return decodeURIComponent(cookie.substring(nameKey.length));
            }
        }
        return "";
    } catch (error) {
        console.error('Error getting legacy cookie:', error);
        return "";
    }
}

function setCookie(name, value, days) {
    if (!name) {
        console.warn('Cookie name is required');
        return;
    }

    try {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        const encodedValue = encodeURIComponent(value || "");
        document.cookie = `${name}=${encodedValue}${expires}; path=/; SameSite=Lax`;
    } catch (error) {
        console.error('Error setting legacy cookie:', error);
    }
}
